module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout-masonry"
  }, [_vm._m(0), _vm._v(" "), _c('masonry-instagram'), _vm._v(" "), _c('section-comment', {
    staticStyle: {
      "margin-top": "50px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      Masonry + Instagram Layout.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n      Masonry + Instagram layout."), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-157feb8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_showcase/LayoutMasonryInstagram.vue
// module id = 802
// module chunks = 1